<template>

    <div class="container">
    <Row>
      <Col span="24" offset="-1" style="background: white;height: 450px;box-shadow: 0.5px 0.5px 3px 0.5px darkgray" >
      <br>
      <br>
      <Col span="10" offset="1" v-if="projectPictureRows!=null && projectPictureRows.length>0">
        <Carousel autoplay loop>
            <CarouselItem v-for="(item,index) in projectPictureRows" :key="index">
            <img :src="item.imgPath" width="100%" >
            </CarouselItem>
        </Carousel>
      </Col>
      <Col span="10" offset="1" v-if="projectPictureRows==null || projectPictureRows.length==0">
        <img :src="img4" width="100%" height="400px">
      </col>
      <Col span="10" offset="1"  align="left" >
      <Col span="24" style="font-size: 24px;line-height:25px;">
      {{project.projectTitle}}
      </Col>
      <Col span="2"> 
	        <div @click="addCollection()"> <template v-if="2==icon"><Icon type="md-star" size='25' style="color:orange"/></template>
          <template v-if="1==icon"><Icon type="md-star-outline"  size='25' style="color:orange" /></template></div>
       </Col>
      <br/>
      <br/>
      <Col span="10" style="font-size: 14px; ">
      拟募集资金金额:<span style="color:red;font-size: 18px;">{{project.money}}</span>万元
      </Col>
      
      <Col span="10" offset="3" style="font-size: 14px; ">所在地：{{project.projectProvince}}
      </Col> 
   
      <br/>
      <br/>
       
      <Col span="10"  style="font-size: 14px; " >
      信息披露期：<span style="color:orange;">{{project.infoDisclosePeriod}}</span>
      </Col>
     
      <Col span="11" offset="3" style="font-size: 14px; ">所属行业：{{project.industry}}
      </Col>  
      
      <br/>
      <br/>
      <Col  span="10" style="font-size: 14px; " >
      保证金：<span style="color:red;">{{project.payDeposit}}</span>
      </Col>
     
      <Col span="10" offset="3" style="font-size: 14px; ">
      经济性质：{{project.economicNature}}
      </Col>
       <br>
      <br>

      <Col offset="5" span="12" style="background: orange; font-size: 25px; ">
      <Icon type="md-call" />
      {{project.phone}}4006-010-661
      </Col>
       <br/>
      <br/>
       <br/>
      <Col>
      <Col  span="15" style="line-height:25px;font-size: 14px; ">
      信息披露开始时间：{{project.infoDiscloseStart}}<br><br>
      信息披露结束时间：{{project.infoDiscloseEnd}}<br>
      </Col>
      </Col>
      <br>
      <br>
       <br>
      <Col span="24" offset="0" style="border: 1px solid ;border-color: lightgray;background: #f6f6f6;line-height:25px;font-size: 14px;">
    {{projectTxt.projectOutline}}
      </Col>
      </Col>
      </Col>
    </Row>
    <br/>
     <!--<Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="4" class="info" v-for="(item,index) in info" :key="index">{{item}}</Col>
        </Col>
       </Row>-->
       <Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="6" class="info" ><a href="#1" style="font-size:18px;color:black;">项目基本信息</a></Col>
        <Col span="4" class="info" ><a href="#2" style="font-size:18px;color:black;">增资方基本情况</a></Col>
        <Col span="4" class="info" ><a href="#3" style="font-size:18px;color:black;">财务信息</a></Col>
        <Col span="6" class="info" ><a href="#4" style="font-size:18px;color:black;">投资方资格条件与增资条件</a></Col>
        <Col span="4" class="info" ><a href="#5" style="font-size:18px;color:black;">其他</a></Col>
        </Col>
       </Row>
       <br/>
    <Row id="1">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="5" offset="-1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">项目基本信息</span>
      
      </Col>
      <Divider />

      <Col offset="1" span="22">
      <table width="100%"  >
        <tr>
          <td>项目名称</td><td>{{projectInfo.projectName}}</td><td>项目编号</td><td>{{projectInfo.projectNo}}</td>
        </tr>
        <tr>
          <td>专业服务机构</td><td>{{projectInfo.entrustedInstitution}}</td><td>交易机构</td><td>{{projectInfo.tradeInstitution}}</td>
        </tr>
        <tr>
          <td>增资方所在地区</td><td>{{projectCapitalIncrease.area}}</td><td>涉及非公开协议增资情况</td><td>{{projectCapitalIncrease.capitalIncrease}}</td>
        </tr>
        <tr>
          <td>拟募资资金金额</td><td>{{projectCapitalIncrease.collectCapital}}</td><td>你征集投资方数量</td><td>{{projectCapitalIncrease.investorNumber}}</td>
        </tr> <tr>
        <td>拟新增注册资本</td><td>{{projectCapitalIncrease.addRegisteredCapital}}</td><td>拟增资价格</td><td>{{projectCapitalIncrease.capitalPrice}}</td>
      </tr>
        <tr>
          <td>增资前每股价值</td><td>{{projectCapitalIncrease.valuePer}}</td><td>增资前每股收益率</td><td>{{projectCapitalIncrease.profitPer}}</td>
        </tr> <tr>
        <td>增资后每股价值</td><td>{{projectCapitalIncrease.valueAfter}}</td><td>增值后每股收益率</td><td>{{projectCapitalIncrease.profitAfter}}</td>
      </tr> <tr>
        <td>增资形式</td><td>{{projectCapitalIncrease.capitalModality}}</td><td>原股东是否参与增资</td><td>{{projectCapitalIncrease.shareholderCapital}}</td>
      </tr> <tr>
        <td>职工参与增资</td><td colspan="3">{{projectCapitalIncrease.staffCapital}}</td>
      </tr> <tr>
        <td>增资方承诺书</td><td colspan="3">{{projectCapitalIncrease.letterCommitment}}</td>
      </tr> <tr>
        <td>拟募集资金对应持股比例或股份数</td><td  colspan="3" >{{projectCapitalIncrease.moneyProportion}}</td>
      </tr> <tr>
        <td>增资后企业股权机构</td><td  colspan="3">{{projectCapitalIncrease.ownershipStructure}}
      </td>
      </tr> <tr>
        <td>对增资有重大影响的相关信息</td><td  colspan="3">{{projectCapitalIncrease.graveNews}}
        
      </td>
      </tr>
       <tr>
        <td>增资专项报告结论</td><td  colspan="3">{{projectCapitalIncrease.reportConclusion}}
        
      </td>
       </tr>
        <tr>
        <td>增资达成或终止条件</td><td  colspan="3">{{projectCapitalIncrease.meetingConditions}}
        
      </td>
       </tr>
        <tr>
        <td>信息发布期满的安排</td><td  colspan="3">{{projectCapitalIncrease.publishArrange}}
        
      </td>
       </tr>
        <tr>
        <td>募集资金用途</td><td  colspan="3">{{projectCapitalIncrease.moneyPurpose}}
        
      </td>
       </tr>
        <tr>
        <td>增资方案主要内容</td><td  colspan="3">{{projectCapitalIncrease.primaryCoverage}}
        
      </td>
       </tr>
       <br>
       <br>
     
      </table>
      </Col>
      </Col>
    </Row>
    <br/>
    <Row id="2">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray; ">
       <Col span="5" offset="-1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">增资方基本情况</span>
      
      </Col>
       <Divider />
      <Col offset="1" span="22">
     <table width="100%" >
       <tr><td >名称</td><td>{{projectEnterprise.companyName}}</td><td >住所</td><td>{{projectEnterprise.registeredAddress}}</td></tr>
          <tr><td >法定代表人</td><td>{{projectEnterprise.legalPerson}}</td><td >成立日期</td><td>{{projectEnterprise.establishmentDate}}</td></tr>
           <tr><td >注册资本</td><td>{{projectEnterprise.registeredCapital}}</td><td >实收资本</td><td>{{projectEnterprise.paidCapital}}</td></tr>
            <tr><td >企业类型</td><td>{{projectEnterprise.companyType}}</td><td >所属行业</td><td>{{projectEnterprise.industry}}</td></tr>
             <tr><td >经济类型</td><td>{{projectEnterprise.economicType}}</td><td >统一社会信用代码</td><td>{{projectEnterprise.unifiedCode}}</td></tr>
              <tr><td >股东个数</td><td>{{projectEnterprise.shareholderNumber}}</td><td >职工人数</td><td>{{projectEnterprise.staffNumber}}</td></tr>
               <tr><td >经营规模</td><td colspan="3">{{projectTxt.scaleOperation}}</td></tr>
                <tr><td >经营范围</td><td colspan="3">{{projectTxt.businessScope}}</td></tr>
     </table>
     <br>
     <br>
      </col>
      </Col>
        </Row>
          <br/>
    <Row id="3">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="2" offset="1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">财务信息</span>
      </col>
       <Divider />
       <Col offset="1" span="22">
       <table width="100%" >
         <tr><td colspan="8">近三年对的年度审计报告</td></tr>
         <tr><td>项目/年度</td><td>营业收入（万元）</td><td>利润总额（万元）</td><td>净利润（万元）</td><td>资产总计（万元）</td><td>负债总计（万元）</td><td>所有者权益（万元）</td><td>审计机构</td></tr>
          <tr v-for="item in projectFinanceRows"><td>{{item.year}}</td><td>{{item.businessIncome}}</td><td>{{item.operatingProfit}}</td><td>{{item.netProfit}}</td>
          <td>{{item.totalAssets}}</td><td>{{item.totalLiabilities}}</td><td>{{item.ownerEquity}}</td><td>{{item.auditOrganization}}</td></tr>
                  
          
           <tr><td colspan="8">最近一期财务数据</td></tr>
                <tr ><td colspan="2">报表日期</td><td colspan="2">{{projectFinanceCompany.year}}</td><td colspan="2">营业收入（万元）</td><td colspan="2">{{projectFinanceCompany.businessIncome}}</td></tr>
                 <tr ><td colspan="2">资金总计（万元）</td><td colspan="2">{{projectFinanceCompany.totalAssets}}</td><td colspan="2">负债总计</td><td colspan="2">{{projectFinanceCompany.totalLiabilities}}</td></tr>
                  <tr ><td colspan="2">估值机构</td><td colspan="2">{{projectAssetValuation.evaluationInstitution}}</td><td colspan="2">估值基准日</td><td colspan="2">{{projectAssetValuation.baseDate}}</td></tr>
                   <tr ><td colspan="2">所有者权益</td><td colspan="2">{{projectFinance.ownerEquity}}</td><td colspan="2">核准备案日期</td><td colspan="2">{{projectAssetValuation.authorizedDate}}</td></tr>
                <tr><td colspan="8">项目</td></tr>
                  <tr><td colspan="2">项目</td><td colspan="3">账面值</td><td colspan="3">估值</td></tr>
                  <tr v-for="item in projectAssetValuationDetailsRows"><td colspan="2">{{item.placeName}}</td><td colspan="3">{{item.bookValue}}</td><td colspan="3">{{item.valuationValue}}</td></tr>
                    <tr><td colspan="2">单位注册资本对应估值</td><td colspan="2">{{projectAssetValuation.evaluationValue}}</td><td colspan="2">评估审核准备菜单</td><td colspan="2">{{projectAssetValuation.authorizedRecord}}</td></tr>
                     <tr><td colspan="2">融资方决策文件类型</td><td colspan="2">{{projectApproval.fileType}}</td><td colspan="2">国资监管机构</td><td colspan="2">{{projectApproval.regulatoryBody}}</td></tr>
                      <tr><td colspan="2">国家出资企业或主管部门名称</td><td colspan="2">{{projectApproval.capitalCompanyName}}</td><td colspan="2">社会统一信用代码</td><td colspan="2">{{projectApproval.capitalUnifiedCode}}</td></tr>
                       <tr><td colspan="2">批准单位名称</td><td colspan="2">{{projectApproval.approveCompanyName}}</td><td colspan="2">批准文件类型</td><td colspan="2">{{projectApproval.approveFileType}}</td></tr>
                        <tr><td colspan="2">批准文件或决议名称（含文号）</td><td colspan="2">{{projectApproval.resolutionFile}}</td><td colspan="2">其他披露事项</td><td colspan="2">{{projectTxt.otherDisclosures}}</td></tr>
       </table>
       <br>
       <br>
       </Col>
      </Col>
      </Row>
       <br/>
   
       <br/>
    <Row id="4">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="7" offset="-1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">投资方资格条件与增资条件</span>
      </col>
        <Divider />
         <Col span="22" offset="1">
      <table width="100%" h>
        <tr><td>投资方资格条件</td><td colspan="3">{{projectPrerequisites.prerequisites}}</td></tr>
        <tr><td>增资条件</td><td colspan="3">{{projectPrerequisites.capitalConditions}}</td></tr>
         <tr><td>缴纳保证金</td><td>{{projectPrerequisites.payDeposit}}</td><td>保证金额或比例</td><td>{{projectPrerequisites.payAmount}}</td></tr>
         <tr><td>缴纳时间</td><td>{{projectPrerequisites.payTime}}</td><td>保证金处置方式</td><td>{{projectPrerequisites.payMode}}</td></tr>
        
      </table>
       <br>
       <br>
      </Col>
      </Col>
     
      </Row>
       <br/>
    <Row id="5">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;overflow:hidden;">
      <Col span="2" offset="-1" style="font-size: 23px">
      <span style="border-bottom:3px solid orange;font-family: 黑体">其他</span>
      </col>
        <Divider />
        <Col span="22" offset="1">
        <table width="100%" >
       <tr><td style="width:25%;">遴选方式</td><td style="width:75%">{{selectionWay[0].attrValue}}</td></tr>
        <tr><td style="width:25%">遴选方式主要内容</td><td style="width:75%">{{selectionWayContent[0].attrValue}}</td></tr>
         <tr><td style="width:25%">采集源地址</td><td style="width:75%">{{collectAddress[0].attrValue}}</td></tr>
          <tr><td style="width:25%">相关附件</td><td style="width:75%">
            <span v-for="item in projectAttachmentRows"><a :href="item.attachmentPath">{{item.attachmentName}}</a></span>
            </td></tr>
        </table>
        <br><br>
        </Col>
      </Col>
      </Row>
    </div>

</template>

<script>
  /*  import itable from "./components/table"; */

    export default {
   /*  components: {itable}, */
      data(){
        return{
            project: [],
            projectInfo: [],
            projectTxt: [],
            projectCapitalIncrease:[],
            projectEnterprise:[],
            projectFinance:[],
            projectApproval:[],
            projectInfo:[],
            projectAssetValuation:[],
            projectAssetValuationDetailsRows:[],
            projectPrerequisites:[],
            //审计数据用的数组
            projectFinanceRows:[],
            //临时用最近一期财务数据
            projectFinanceCompany:[],
            img4:"../../../static/noImg.png",
            dataList: [],
            Enclosure:[],
            projectPictureRows:[],
            projectAttachmentRows:[],
            selectionWay:[
              {attrName:'遴选方式',attrValue:''}
            ],
            selectionWayContent:[
              {attrName:'遴选方案主要内容',attrValue:''}
            ],
            collectAddress:[
              {attrName:'采集源地址',attrValue:''}
            ],
            info:['项目基本信息','增资方基本情况','财务信息','投资方基本情况','其他']
        
        }
      },
      mounted(){
         this.getProject();
      },
      methods:{
      getProject:function(){
          let that=this;
          protocol.param_projectDetail.data.projectId=this.$route.query.detailId;      
          http.gets(protocol.param_projectDetail,protocol.param_projectDetail.data).then(response => {
             let {msg,code,project,projectInfo,projectCapitalIncrease,projectEnterprise,projectFinanceRows,projectFinance,projectPrerequisites,projectTransfer,
             projectTxt,projectAssetValuation,projectAssetValuationDetailsRows,projectApproval,projectAttrRows,projectPictureRows,projectAttachmentRows} = response.data;
             console.log(msg);
        if (code === 0) {

            if(project!=null){
              this.project = project;
            }
            if(projectInfo!=null){
                this.projectInfo = projectInfo;
            }
            if(projectTxt!=null){
                this.projectTxt = projectTxt;
            }
            if(projectCapitalIncrease!=null){
                this.projectCapitalIncrease = projectCapitalIncrease;
            }
            if(projectEnterprise!=null){
                this.projectEnterprise = projectEnterprise;
            }
            if(projectAssetValuation!=null){
                this.projectAssetValuation = projectAssetValuation;
            }
            if(projectApproval!=null){
                this.projectApproval = projectApproval;
            }
            if(projectPrerequisites!=null){
                this.projectPrerequisites = projectPrerequisites;
            }
            //资产明细
            for(let value of projectAssetValuationDetailsRows){
              this.projectAssetValuationDetailsRows.push(value);
            }
            //财务信息
            for(let item in projectFinanceRows){
              if(projectFinanceRows[item].type == 'F01'){
                this.projectFinanceRows.push(projectFinanceRows[item]);
              }else{
                this.projectFinanceCompany=projectFinanceRows[item];
              }
            }
            for(let item in projectAttrRows){
              if(projectAttrRows[item].attrName == '遴选方式'){
                this.selectionWay[0].attrValue = projectAttrRows[item].attrValue;
              }else if(projectAttrRows[item].attrName == '遴选方案主要内容'){
                this.selectionWayContent[0].attrValue = projectAttrRows[item].attrValue;
              }else if(projectAttrRows[item].attrName == '采集源地址'){
                this.collectAddress[0].attrValue = projectAttrRows[item].attrValue;
              }
            }
            //自定义属性
            if(projectAttrRows!=null && projectAttrRows.length>0){
                    this.collectAddress = projectAttrRows;
            }
            //图片信息
            if(projectPictureRows!=null && projectPictureRows.length>0){
                    this.projectPictureRows = projectPictureRows;
            }
            //附件信息
           if(projectAttachmentRows!=null && projectAttachmentRows.length>0){
                  this.projectAttachmentRows = projectAttachmentRows;
           }
        }else{
          this.dataList = [];
         
        }
      });
},
addCollection:function(){
    protocol.param_addCollection.data.collectionId=this.$route.query.detailId; ;      
    protocol.param_addCollection.data.type = '1';
    http.posts(protocol.param_addCollection,protocol.param_addCollection.data).then(response => {
         let {msg,code} = response.data;
         if(code=='401'){
            //this.$message({ type: "warning", message: "还未登录，请先登录" });
            //alert("还未登录，请先登录");
            this.$Message.info("还未登录，请先登录");
            this.$router.push({path:'/load'});
          }else if(code==0){
            this.$Message.info(msg);
          }else{
            this.icon=2;
            this.$Message.info(msg);
          }
      });
}
  
      }

    }
</script>

<style scoped>
 td{
    border: 1px solid lightgray;
    height: 50px;
    font-size: 14px;
  }
  tr{ border: 1px solid lightgray}
  tr:hover{
    background: whitesmoke;
  }
  td:nth-child(2n-1){
    background:#F5F5F5;
    width:240px;

  }
  td:nth-child(2n){
    
     width:240px;
  }


  table{border-collapse: collapse;
    cursor: pointer;
    padding: 5%;
   
  }
    .info{
      line-height:110px; 
      font-size:15px;
       cursor: pointer;
    }
    .info:hover{
      color: orange
     
    }
</style>



// WEBPACK FOOTER //
// src/views/detail/detail2.vue